import React from 'react';
import PropTypes from 'prop-types';

const SunIcon = ({ className }) => {
  return (
    <svg width="54" height="54" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
    fill="currentColor" // Ensures the color can be changed dynamically
    >
    <path d="M27 41.625C35.0772 41.625 41.625 35.0772 41.625 27C41.625 18.9228 35.0772 12.375 27 12.375C18.9228 12.375 12.375 18.9228 12.375 27C12.375 35.0772 18.9228 41.625 27 41.625Z" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M43.065 43.065L42.7725 42.7725M42.7725 11.2275L43.065 10.935L42.7725 11.2275ZM10.935 43.065L11.2275 42.7725L10.935 43.065ZM27 4.68V4.5V4.68ZM27 49.5V49.32V49.5ZM4.68 27H4.5H4.68ZM49.5 27H49.32H49.5ZM11.2275 11.2275L10.935 10.935L11.2275 11.2275Z" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    
  );
};

SunIcon.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

SunIcon.defaultProps = {
  className: '', // Default to an empty string
};

export default SunIcon;